// Post background themes — used by the community feed composer.
// When a member picks a theme, short text posts render as a bold, tappable
// "greeting card" style on top of that background. Clicking the card copies a
// shareable permalink so the moment can be sent to a friend outside the app.

export const POST_THEMES = [
  {
    id: "none",
    label: "Plain",
    swatch: "linear-gradient(135deg,#FDFBF7 0%,#F5F2EA 100%)",
    background: "#FDFBF7",
    text: "#1A2B4C",
    accent: "#722F37",
  },
  {
    id: "gold",
    label: "Gold hour",
    swatch: "linear-gradient(135deg,#D4AF37 0%,#F1D46B 60%,#EED28E 100%)",
    background: "linear-gradient(135deg,#D4AF37 0%,#F1D46B 55%,#B8962A 100%)",
    text: "#1A2B4C",
    accent: "#5C252C",
  },
  {
    id: "royal",
    label: "Royal blue",
    swatch: "linear-gradient(135deg,#1A2B4C 0%,#2E4573 100%)",
    background: "linear-gradient(140deg,#1A2B4C 0%,#2E4573 60%,#0F1A32 100%)",
    text: "#FDFBF7",
    accent: "#D4AF37",
  },
  {
    id: "burgundy",
    label: "Burgundy",
    swatch: "linear-gradient(135deg,#722F37 0%,#9C4149 100%)",
    background: "linear-gradient(140deg,#5C252C 0%,#722F37 55%,#9C4149 100%)",
    text: "#FDFBF7",
    accent: "#D4AF37",
  },
  {
    id: "sunrise",
    label: "Sunrise",
    swatch: "linear-gradient(135deg,#F6B36C 0%,#F28C63 60%,#E8695C 100%)",
    background: "linear-gradient(140deg,#F6B36C 0%,#F28C63 50%,#E8695C 100%)",
    text: "#1A2B4C",
    accent: "#5C252C",
  },
  {
    id: "still-waters",
    label: "Still waters",
    swatch: "linear-gradient(135deg,#8FBFD1 0%,#4E90A6 100%)",
    background: "linear-gradient(140deg,#B7D9E4 0%,#8FBFD1 45%,#4E90A6 100%)",
    text: "#0F2A3A",
    accent: "#1A2B4C",
  },
  {
    id: "olive",
    label: "Olive grove",
    swatch: "linear-gradient(135deg,#8FA36F 0%,#4E6742 100%)",
    background: "linear-gradient(140deg,#B7C79A 0%,#8FA36F 45%,#4E6742 100%)",
    text: "#1A2B0F",
    accent: "#5C252C",
  },
  {
    id: "lily",
    label: "Lily of the valley",
    swatch: "linear-gradient(135deg,#F7E3E9 0%,#F0B7C7 60%,#D48EA7 100%)",
    background: "linear-gradient(140deg,#F7E3E9 0%,#F0B7C7 50%,#D48EA7 100%)",
    text: "#4A1024",
    accent: "#722F37",
  },
  {
    id: "midnight",
    label: "Midnight prayer",
    swatch: "linear-gradient(135deg,#0B0F1F 0%,#1A2B4C 100%)",
    background: "radial-gradient(ellipse at top left,#2E4573 0%,#0B0F1F 70%)",
    text: "#FDFBF7",
    accent: "#D4AF37",
  },
  {
    id: "manna",
    label: "Manna",
    swatch: "linear-gradient(135deg,#FFF6D6 0%,#F1D46B 100%)",
    background: "linear-gradient(140deg,#FFF6D6 0%,#F5E3A0 55%,#F1D46B 100%)",
    text: "#4A3410",
    accent: "#722F37",
  },
];

export const POST_THEME_MAP = POST_THEMES.reduce((acc, t) => {
  acc[t.id] = t;
  return acc;
}, {});

export const POST_THEME_IDS = POST_THEMES.map((t) => t.id);

// Scope subsets. The Book Club discussion intentionally uses a calmer palette
// so heavy conversation about grief, illness, or Scripture doesn't clash with
// a bold gold or midnight-navy backdrop. Groups keep the full palette so
// members can still be expressive when sharing a praise inside a prayer group.
const BOOKCLUB_THEME_IDS = ["none", "manna", "still-waters", "olive", "lily"];

export function getThemesForScope(scope) {
  if (scope === "bookclub") {
    return POST_THEMES.filter((t) => BOOKCLUB_THEME_IDS.includes(t.id));
  }
  // "feed" and "group" both get the full palette.
  return POST_THEMES;
}

// Maximum characters the themed hero style is applied for. Longer posts still
// keep the theme metadata but render on a normal card so the copy stays readable.
export const THEMED_MAX_CHARS = 280;

export function getPostTheme(id) {
  if (!id) return POST_THEME_MAP.none;
  return POST_THEME_MAP[id] || POST_THEME_MAP.none;
}
